import React, {useState} from 'react';
import { ComposedChart, Bar, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, Label, LabelList, Line, Tooltip } from 'recharts';
import styles from "./barAndLineComboChart.module.css";

const BarAndLineComboChartAlternateSite = ({ details }) => {
    // const transformedData = details?.map(item => ({
    //     site: item["Alternate site"],
    //     flexCapacity: item["Flex capacity (in T)"] || 0,
    //     rmCoverage: item["RM coverage (in T)"] || 0,
    //     requiredCapacity: item["Required capacity(in T)"] || 0,
    //     leadTime: item["Average LT (3 Depots)"] || 0
    // }));
    const transformedData = details?.map(item => ({
        site: item["Site code"],
        siteCluster:item["Site cluster"],
        flexCapacity: item["Flex Capacity"]?.toFixed(1) || 0,
        // rmCoverage: item["RM coverage (in T)"] || 0,
        requiredCapacity: item["Required Capacity"]?.toFixed(1) || 0,
        leadTime: item["Average LT"] || 0, 
        top3Depots:item["Top 3 depots (Lane existing, Transit Time, KM)"] || null,
        distanceInKM : item["distanceInKM"] || 0
    }));

    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };
    // Custom floating tooltip for axis label
    const FloatingTooltip = ({ text, x, y }) => {
        const fontSize = 10;
        const charWidth = fontSize * 0.65; // average character width in px
        const padding = 13;
        const wdth = text.length * charWidth + padding;
        return (
            <foreignObject x={x} y={y + 6} width={wdth} height={40}>
            <div
                style={{
                    background: '#666',
                    color: '#fff',
                    padding: '5px 8px',
                    borderRadius: '4px',
                    fontSize: '10px',
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none', 
                    textTransform: 'uppercase' 
                }}
            >
                {text}
            </div>
            </foreignObject>
        );
    };
    // Custom tick component for XAxis
    const CustomXAxisTick = ({ x, y, payload }) => {
        const [hovered, setHovered] = useState(false);

        const shortText =
            payload.value.length > 8 ? payload.value.slice(0, 8) + '…' : payload.value;

        return (
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={0}
                    dy={16}
                    textAnchor="middle"
                    fill="#666"
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                >
                    {shortText}
                </text>
                {hovered && <FloatingTooltip text={payload.value} x={-50} y={18} />}
            </g>
        );
    };
    const CustomTooltip = ({ active, payload }) => {
        console.log("Playload", payload)
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    <p><span style={{ fontWeight: 500 }}>{'Site code'}</span> : {payload[0].payload?.site}</p>
                    <p><span style={{ fontWeight: 500 }}>{'Site cluster'}</span> : {payload[0].payload?.siteCluster}</p>
                    {payload.map((item, index) => {
                        const valueWithSuffix = item.value;
                        return (
                            <p key={index} className={styles.tooltipItem}>
                                <span style={{ fontWeight: 500 }}>{item.name}</span> : {valueWithSuffix}
                            </p>
                        );
                    })}
                    <p><span style={{ fontWeight: 500 }}>{'Avg. KM'}</span> : {payload[0].payload?.distanceInKM?.toFixed(1)}</p>
                </div>
            );
        }
        return null;
    };
    // Calculate Y axis domain
    const allValues = transformedData.flatMap(item => [
        parseFloat(item.flexCapacity),
        parseFloat(item.requiredCapacity),
        parseFloat(item.leadTime)
    ]);
    const maxValue = Math.max(...allValues);
    const steps = 5;
    const stepSize = maxValue / (steps - 1);
    const yAxisTicks = Array.from({ length: steps }, (_, i) => parseFloat((i * stepSize)?.toFixed(1)));
    // End
    return (
        <>

            <ResponsiveContainer width="100%" height={220}>
                <ComposedChart data={transformedData}
                    margin={{
                        top: 15,
                        right: 0,
                        bottom: 10,
                        left: 0,
                    }} >
                    <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                    <XAxis 
                        dataKey="site" 
                        tickLine={false} 
                        axisLine={false} 
                        className={styles.BarLabel}
                        tick={<CustomXAxisTick />}
                        interval={0} 
                        padding={{ left: 0, right: 0 }} 
                    >
                    </XAxis>
                    <YAxis
                        yAxisId="left"
                        domain={[0, maxValue]} 
                        ticks={yAxisTicks}
                        tickLine={false}
                        axisLine={false}
                        className={styles.BarLabel}
                        padding={{ left: 0, right: 0 }}
                    >
                        <Label
                            value="Quantity (tonnes)"
                            angle={-90}
                            offset={15}
                            position="insideLeft"
                            style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500', textAnchor: "middle" }}
                        />
                    </YAxis>
                    
                    <YAxis                       
                        yAxisId="right"
                        orientation="right"
                        domain={[0, 'auto']}
                        tickLine={false}
                        axisLine={false}
                        className={styles.BarLabel}
                        padding={{ left: 0, right: 0 }}
                    >
                        <Label
                            value="Days"
                            angle={-90}
                            offset={15}
                            position="insideRight"
                            style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500', textAnchor: "middle" }}
                        />
                    </YAxis>
                    <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />
                    <Tooltip
                        content={<CustomTooltip />}
                        wrapperStyle={{
                            fontSize: '12px',
                            padding: '6px',
                        }}
                    />
                    <Bar
                        yAxisId="left"
                        radius={[4, 4, 0, 0]}
                        dataKey="flexCapacity"
                        name="Flex capacity (in T)"
                        fill="#005EEF"
                        barSize={20}
                    >
                        <LabelList
                            dataKey="flexCapacity"
                            position="top"
                            style={{ fill: '#2B2B2B', fontSize: 10, fontWeight: "500" }}
                        />
                    </Bar>
                    {/* <Bar
                        yAxisId="left"
                        dataKey="rmCoverage"
                        name="RM coverage (in T)"
                        fill="#00B190"
                        barSize={20}
                        radius={[4, 4, 0, 0]}
                    >
                        <LabelList
                            dataKey="rmCoverage"
                            position="top"
                            style={{ fill: '#2B2B2B', fontSize: 10, fontWeight: "500" }}
                        />
                    </Bar> */}
                    <Line yAxisId="left" type="monotone" dataKey="requiredCapacity" name="Required capacity(in T)" stroke="#9C44C0" fill="#9C44C0" strokeWidth={1} />
                    <Line yAxisId="right" type="monotone" dataKey="leadTime" name="Avg. Transit Time" stroke="#FF9E00" fill="#FF9E00" strokeWidth={1} />
                </ComposedChart>
            </ResponsiveContainer>
        </>

    );
};

export default BarAndLineComboChartAlternateSite;